"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDateFormatToDatePattern = mapDateFormatToDatePattern;
var _types = require("../types");
/**
 * Returns date formatting pattern selected from the {@link patterns} or {@link customPattern custom pattern} parameters according to the given date {@link format} value.
 * @param format The date format
 * @param patterns An object containing available date formatting patterns
 * @param customPattern Specifies a custom pattern (e.g. 'dd.MM.yyyy') for the date formatting
 * @returns Date formatting pattern
 */
function mapDateFormatToDatePattern(format, patterns, customPattern) {
  if (!patterns) {
    return undefined;
  }
  switch (format) {
    case _types.DateFormat.FullDateTime:
      return patterns.fullDateTimePattern;
    case _types.DateFormat.LongDate:
      return patterns.longDatePattern;
    case _types.DateFormat.LongTime:
      return patterns.longTimePattern;
    case _types.DateFormat.MonthDay:
      return patterns.monthDayPattern;
    case _types.DateFormat.ShortDateLongTime:
      return patterns.shortDateLongTimePattern;
    case _types.DateFormat.ShortDate:
      return patterns.shortDatePattern;
    case _types.DateFormat.ShortDateTime:
      return patterns.shortDateTimePattern;
    case _types.DateFormat.ShortTime:
      return patterns.shortTimePattern;
    case _types.DateFormat.SortableDateTime:
      return patterns.sortableDateTimePattern;
    case _types.DateFormat.UniversalSortableDateTime:
      return patterns.universalSortableDateTimePattern;
    case _types.DateFormat.YearMonth:
      return patterns.yearMonthPattern;
    case _types.DateFormat.Custom:
      if (!customPattern) {
        throw new Error("It's mandatory to specify custom date format pattern for Custom Type!");
      }
      return customPattern;
    default:
      return undefined;
  }
}
